import {useState, useEffect} from 'react'
const useDurationEvent = (durationData) => {
	const [durationList, setDurationList] = useState([])

	// Generate a simple unique ID
	const generateId = () =>
		`id-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`

	// 백엔드 데이터가 왔을 때, 해당 값으로 State 초기화
	useEffect(() => {
		if (durationData) {
			const tmpList = []
			durationData.forEach((elem) => {
				const tmp = []
				tmp.push(elem[0] === 'break' ? 'break' : null)
				tmp.push(elem[1])
				tmp.push(elem[0] === 'break' ? 'empty' : elem[2])
				tmp.push(elem[0] === 'break' ? 'empty' : elem[3])
				tmp.push(elem[0] === 'break' ? 'empty' : elem[4])

				// Wrap with ID for DnD
				tmpList.push({id: generateId(), data: tmp})
			})
			setDurationList(tmpList)
		}
	}, [durationData])

	// ===== 듀레이션 관련 이벤트 =====

	const setDuration = (e, type, index) => {
		const tmpList = [...durationList]
		const item = {...tmpList[index]}
		const tmpElem = [...item.data]
		const value = e.target.value

		if (type === 1) {
			// Minute 수정
			tmpElem[type] = value
		} else if (type === 2) {
			// SB 수정
			tmpElem[type] = value
			tmpElem[type + 1] = value * 2
			tmpElem[type + 2] = value * 2
		} else if (type === 3) {
			// BB 수정
			tmpElem[type] = value
			tmpElem[type + 1] = value
		} else if (type === 4) {
			// Ante 수정
			tmpElem[type] = value
		}

		item.data = tmpElem
		tmpList[index] = item
		setDurationList(tmpList)
	}

	const createDurationEvent = () => {
		const tmpList = [...durationList]
		tmpList.push({id: generateId(), data: [null, null, null, null, null]})
		setDurationList(tmpList)
	}

	const createBreakEvent = () => {
		const tmpList = [...durationList]
		tmpList.push({
			id: generateId(),
			data: ['break', null, 'empty', 'empty', 'empty'],
		})
		setDurationList(tmpList)
	}

	// Insert section below specific index
	const insertDurationEvent = (index) => {
		const tmpList = [...durationList]
		const newItem = {id: generateId(), data: [null, null, null, null, null]}
		tmpList.splice(index + 1, 0, newItem)
		setDurationList(tmpList)
	}

	// Insert break below specific index
	const insertBreakEvent = (index) => {
		const tmpList = [...durationList]
		const newItem = {
			id: generateId(),
			data: ['break', null, 'empty', 'empty', 'empty'],
		}
		tmpList.splice(index + 1, 0, newItem)
		setDurationList(tmpList)
	}

	const deleteDurationEvent = (index) => {
		const tmpList = [...durationList]
		tmpList.splice(index, 1)
		setDurationList(tmpList)
	}

	const moveDurationEvent = (fromIndex, toIndex) => {
		if (fromIndex === toIndex) return
		if (fromIndex < 0 || toIndex < 0) return

		setDurationList((items) => {
			const newItems = [...items]
			if (fromIndex >= newItems.length) return items

			const [movedItem] = newItems.splice(fromIndex, 1)
			newItems.splice(toIndex, 0, movedItem)
			return newItems
		})
	}

	return [
		durationList,
		setDuration,
		createDurationEvent,
		createBreakEvent,
		deleteDurationEvent,
		insertDurationEvent,
		insertBreakEvent,
		moveDurationEvent,
	]
}

export default useDurationEvent
